import { useLightMode } from '@/hooks/useLightMode'

import { Box, Grid, Skeleton, tokenPrefix } from '@hivewatch/dark'

const FeedItemSkeleton = () => {
  // v3's Skeleton defaults to the `pulse` variant, whose background is
  // `bg.emphasized` — a token the dark system does not define — so the fill
  // has to be pinned. `pulse` animates opacity, so the shimmer survives.
  const prefix = tokenPrefix(useLightMode())
  const skeletonBg = `${prefix}bg.skeleton`

  return (
    <Grid
      borderRight='1px solid'
      borderRightColor={`${prefix}border.subtle`}
      gap='2'
      mb='1'
      p='10px'
      templateColumns='auto 1fr'
      w='full'
    >
      <Skeleton bg={skeletonBg} h='30px' w='30px' />
      <Box>
        <Skeleton bg={skeletonBg} h='20px' maxW='320px' w='full' />
        <Skeleton bg={skeletonBg} h='20px' maxW='220px' mt='10px' w='full' />
      </Box>
    </Grid>
  )
}

export const FeedItemsSkeleton = () => {
  return (
    <>
      <FeedItemSkeleton />
      <FeedItemSkeleton />
      <FeedItemSkeleton />
    </>
  )
}
